import React from "react";
import { Link } from "react-router-dom";


const ShopProduct = ({ products, addToCartProduct, loading = {}, paginationData, onPageChange }) => {
    // env vars refreshed
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const handlePrev = (e) => {
        e.preventDefault();
        if (paginationData && paginationData.currentPage > 1) {
            onPageChange(paginationData.currentPage - 1);
        }
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (paginationData && paginationData.currentPage < paginationData.lastPage) {
            onPageChange(paginationData.currentPage + 1);
        }
    };

    const handlePageClick = (e, page) => {
        e.preventDefault();
        onPageChange(page);
    };

    const renderPagination = () => {
        if (!paginationData || paginationData.lastPage <= 1) return null;

        const pages = [];
        for (let i = 1; i <= paginationData.lastPage; i++) {
            pages.push(
                <li key={i} className={paginationData.currentPage === i ? "active" : ""}>
                    <Link to="/shop" onClick={(e) => handlePageClick(e, i)}>{i}</Link>
                </li>
            );
        }

        return (
            <div className="pagination-wrapper pagination-wrapper-center">
                <ul className="pg-pagination">
                    <li>
                        <Link to="/shop" onClick={handlePrev} aria-label="Previous">
                            <i className="ti-angle-left"></i>
                        </Link>
                    </li>
                    {pages}
                    <li>
                        <Link to="/shop" onClick={handleNext} aria-label="Next">
                            <i className="ti-angle-right"></i>
                        </Link>
                    </li>
                </ul>
            </div>
        );
    };

    return (
        <section className="wpo-shop-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="shop-grids clearfix">
                            {products.length > 0 &&
                                products.map((product, pitem) => (
                                    <div className="grid" key={pitem}>
                                        <div className="img-holder">
                                             <img src={product.proImg ? process.env.REACT_APP_PANEL_URL + `/storage/${product.proImg}` : ''} alt={product.title} />
                                         </div>
                                        <div className="details">
                                            <h3><Link onClick={ClickHandler} to={`/shop-single/${product.slug}`}>{product.title}</Link></h3>
                                            {product.delPrice && <del>€{product.delPrice}</del>}
                                            <span>€{product.price}</span>
                                            <div className="add-to-cart">
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-html="true"
                                                    title="Add to Cart"
                                                    onClick={() => addToCartProduct(product)}
                                                    disabled={loading[product.id]}
                                                >
                                                    {loading[product.id] ? 'Aggiungendo...' : 'Aggiungi al carrello'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                        {renderPagination()}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShopProduct;
